// extracted by mini-css-extract-plugin
export default {"productImg":"AdminMobileAllStoreSaleList_productImg__rm7Ht","list":"AdminMobileAllStoreSaleList_list__xAffP"};